import React from "react";
import "../../css/loading.scss";

/**
 * Loading 组件 - 显示加载动画
 * @param {string} size - 尺寸: 'small' | 'medium' | 'large' (默认: 'medium')
 * @param {string} text - 加载文本 (可选)
 * @param {boolean} fullScreen - 是否全屏显示 (默认: false)
 */
const Loading = ({
  size = "medium",
  text = "加载中...",
  fullScreen = false,
}) => {
  const sizeMap = {
    small: 24,
    medium: 48,
    large: 72,
  };

  const spinnerSize = sizeMap[size] || sizeMap.medium;

  return (
    <div className={`loading-container ${fullScreen ? "fullscreen" : ""}`}>
      <div className="loading-content">
        <svg
          className="loading-spinner"
          width={spinnerSize}
          height={spinnerSize}
          viewBox="0 0 50 50"
        >
          <circle
            className="loading-path"
            cx="25"
            cy="25"
            r="20"
            fill="none"
            strokeWidth="4"
          />
        </svg>
        {text && <p className="loading-text">{text}</p>}
      </div>
    </div>
  );
};

export default Loading;
